import { createRoute } from "@tanstack/react-router";

import validation from "core/validation";

import { root } from "routes";
import Layout from "theme/ui/Layout";

import Confirm from "areas/auth/page/Confirm";
import Login from "areas/auth/page/Login";
import Signup from "areas/auth/page/Signup";


const _root = createRoute({
	getParentRoute: () => root,
	path: "auth",
	component: () => <Layout.Dark />
});

const login = createRoute({
	getParentRoute: () => _root,
	path: "/",
	component: () => <Login />,
	beforeLoad: validation.redirect.authenticated,
	staticData: {
		lite: true
	}
});

const signup = createRoute({
	getParentRoute: () => _root,
	path: "signup",
	component: () => <Signup />,
	beforeLoad: validation.redirect.authenticated,
	staticData: {
		lite: true
	}
});

const confirm = createRoute({
	getParentRoute: () => _root,
	path: "confirm",
	component: () => <Confirm />,
	beforeLoad: validation.redirect.authenticated,
	staticData: {
		lite: true,
		footer: "lite"
	}
});

const update = createRoute({
	getParentRoute: () => _root,
	path: "update",
	component: () => <Confirm />,
	staticData: {
		lite: true
	}
});


const auth = _root.addChildren([login, signup, confirm, update]);
export default auth;